import React, { useEffect, useState } from 'react'
import { Table } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import ReactPaginate from 'react-paginate';
import Accordion from 'react-bootstrap/Accordion';
import Offcanvas from 'react-bootstrap/Offcanvas';

import axios from 'axios';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import { adminMainUrl } from '../../../../Config';
import { getOperationExpenseDetail, getOperationExpenseList, getOperationExpenseRemarksList } from '../../../../Redux/action/OperationExpense/OperationExpenseAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import AddOperationExpenseOffcanvas from './AddOperationExpenseOffcanvas';
import { getCurrency, getExpenseType } from '../../../../Redux/action/MasterAction';
import RoundedSmallButton from '../../../../Common/RoundedButton/RoundedSmallButton';
import EditOperationExpenseOffcanvas from './EditOperationExpenseOffcanvas';


const OperationExpense = ({ accessedPermission }) => {
    const { b64id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showLoader, setshowLoader] = useState(false);


    const [expense_id, setExpense_id] = useState(null);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);




    useEffect(() => {
        if (token && user_id) {
            if (!b64id) {
                toast.error("Please enter correct URL.");
                navigate(-1);
            } else {
                dispatch(getExpenseType(token, user_id));
                dispatch(getCurrency(token, user_id));
                let job_order_id = atob(b64id);
                if (job_order_id) {
                    dispatch(getOperationExpenseList(token, user_id, job_order_id, queryParams.get("page") ?? 1, queryParams.get('search')));
                } else {
                    toast.error("Please enter correct URL.");
                    navigate(-1);
                }
            }
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, b64id, location.pathname, location.search]);


    const refresh = () => {
        if (token && user_id) {
            let job_order_id = atob(b64id);
            if (job_order_id) {
                dispatch(getOperationExpenseList(token, user_id, job_order_id, queryParams.get("page") ?? 1, queryParams.get('search')));
            } else {
                toast.error("Please enter correct URL.");
                navigate(-1);
            }
        }
    }


    const [showAdd, setShowAdd] = useState(false);
    const handleOpenAdd = () => { setShowAdd(true) };
    const handleCloseAdd = () => { setShowAdd(false) };


    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => { setShowEdit(false) };

    const [showRemarks, setShowRemarks] = useState(false);
    const handleCloseRemarks = () => { setShowRemarks(false) };
    const handleOpenEdit = (id) => {
        if (id) {
            setExpense_id(id);
            setShowEdit(true);
        } else {
            toast.error("Id not found. Please retry.")
        }
    };

    const handleShowRemarks = (expense_id) => {
        if (expense_id) {
            setExpense_id(expense_id);
            setShowRemarks(true);
        } else {
            toast.error("Id not found. Please retry.")
        }
    };



    useEffect(() => {
        if (token && user_id && expense_id) {
            dispatch(getOperationExpenseDetail(token, user_id, expense_id));
            dispatch(getOperationExpenseRemarksList(token, user_id, expense_id));
        }
    }, [expense_id]);

    const refreshRemarks = () => {
        if (token && user_id && expense_id) {
            dispatch(getOperationExpenseRemarksList(token, user_id, expense_id));
        }
    }




    const {
        loadingOperationExpenseList,
        OperationExpenseList,
        OperationExpenseListError,
        OperationExpenseListCurrentPage,
        OperationExpenseListTotalPage,
        OperationExpenseListTotalData,
        OperationExpenseListJobOrderNumber,
        OperationExpenseListJobOrderLocked,
        OperationExpenseListJobOrderID,
        OperationExpenseListQuotationNumber,
        OperationExpenseListHasQuotationNumber,



        loadingOperationExpenseRemarkList,
        OperationExpenseRemarkList,
        OperationExpenseRemarkListError,

        loadingOperationExpenseDetail,
        OperationExpenseDetail,
        OperationExpenseDetailError
    } = useSelector(state => state?.OperationExpenseReducer);

    const {
        loadingExpenseType,
        ExpenseTypeData,
        ExpenseTypeDataError,

        loadingCurrency,
        currencyData,
        currencyDataError,

    } = useSelector(state => state?.MasterReducer);


    const [remarkMessage, setRemarkMessages] = useState([]);
    useEffect(() => {
        if (OperationExpenseRemarkList) {
            let arr = [];
            OperationExpenseRemarkList.map(v => arr.push(v));
            setRemarkMessages(arr);
        }
    }, [OperationExpenseRemarkList])

    const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);
    useEffect(() => {
        if (ExpenseTypeData) {
            let arr = [];
            ExpenseTypeData.map(val => { if (val.status) { arr.push({ value: val.id, label: val.name }) } });
            setExpenseTypeOptions(arr);
        }
    }, [ExpenseTypeData])
    const [currencyOptions, setCurrencyOptions] = useState([]);
    useEffect(() => {
        if (currencyData) {
            let arr = [];
            currencyData.map(val => arr.push({ value: val.id, label: `${val.currency} (${val.currency_symbol})` }));
            setCurrencyOptions(arr);
        }
    }, [currencyData])


    const [dataSource, setDataSource] = useState([]);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Expense ID", dataIndex: "expense_id", key: "expense_id" },
        { title: "Expense Type", dataIndex: "expense_type", key: "expense_type" },
        { title: "Expense Name", dataIndex: "expense_name", key: "expense_name" },
        { title: "Amount", dataIndex: "amount", key: "amount" },
        { title: "Attachment", dataIndex: "attachment", key: "attachment" },
        { title: "Status", dataIndex: "status", key: "status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];




    useEffect(() => {
        if (loadingOperationExpenseList) {
            setshowLoader(true);
        } else {
            setshowLoader(false);
        }

        // console.log(OperationExpenseListJobOrderNumber,OperationExpenseListQuotationNumber);
        if (OperationExpenseList) {

            let arr = [];
            OperationExpenseList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: (queryParams.get("page") ? Number(queryParams.get("page")) - 1 : 0) * 10 + i + 1,
                    expense_id: val.oe_unique_id, // Ensure date formatting as neede
                    expense_type: val?.expense_type ? val.expense_type.name : "",
                    expense_name: val?.expense_name,
                    amount: `${val?.amount} ${val.expense_currency ? val.expense_currency.currency : ""}`,
                    attachment: <>
                        <a target='_blank' href={`${adminMainUrl}/${val.attatchment}`} title="View Attachment">
                            <i className='fa-solid fa-eye text-blue'></i>
                        </a>
                    </>,
                    status: val?.current_status == "EXPENSE APPROVED" ? <b className='text-success'>{val.current_status}</b> : val.current_status,
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                {/* <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleOpenEdit(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </div>
                                </div> */}
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="dropdown-item cursor-pointer" onClick={() => handleShowRemarks(val.id)} >
                                        <i className="fa-regular fa-comment text-blue me-2"></i> Remarks
                                    </div>
                                    {(OperationExpenseListJobOrderLocked == false) && <div className="dropdown-item cursor-pointer" onClick={() => handleOpenEdit(val.id)} >
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </div>}
                                </div>
                            </div>
                        </>
                    )
                })
            });


            setDataSource(arr);
        }
    }, [loadingOperationExpenseList, OperationExpenseList]);


    useEffect(() => {
        if (OperationExpenseListCurrentPage) {
            setCurrentPage(OperationExpenseListCurrentPage);
        }


        if (OperationExpenseListTotalPage) {
            setTotalPages(OperationExpenseListTotalPage)
        }
    }, [
        OperationExpenseListCurrentPage,
        OperationExpenseListTotalPage,
        OperationExpenseListTotalData
    ]);




    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    //search functionality
    let initialValues = {
        search_text: "",
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            const search_text = values.search_text.trim();
            const currentUrl = new URL(window.location.href);


            if (search_text) {
                currentUrl.searchParams.set("search", search_text);
            } else {
                currentUrl.searchParams.delete("search");
            }
            navigate(`${currentUrl.pathname}${currentUrl.search}`);
        }
    });


    //add remark
    let intialValuesRemark = {
        remark: "",
    };
    const [disableRemarkSubmit, setDisableRemarkSubmit] = useState(false);
    const formikRemark = useFormik({
        initialValues: intialValuesRemark,
        onSubmit: (values, { resetForm }) => {
            try {
                if (!expense_id) {
                    toast.error("Couln't find expense ID.");
                    return;
                };
                values.expense_id = expense_id;
                setDisableRemarkSubmit(true);
                let config = {
                    headers: {
                        "user_id": user_id,
                        "auth-token": token
                    }
                }
                axios.post(`${adminMainUrl}/api/jobOrder/operation/expense/add-remark`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableRemarkSubmit(false);
                            // handleClose();
                            resetForm();
                            refreshRemarks();
                        } else {
                            toast.error(response.data.msg);
                            setDisableRemarkSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error";
                        if (error && error.response && error.response.data && error.response.data.msg) {
                            msg = error.response.data.msg;
                        };
                        toast.error(msg);
                        setDisableRemarkSubmit(false);
                    });
            } catch (error) {
                let msg = "Internal server error";
                if (error && error.message) {
                    msg = error.message;
                };
                toast.error(msg);
                setDisableRemarkSubmit(false);
            }
        }
    });




    useEffect(() => {
        if (queryParams.get("search")) {
            console.log(queryParams.get("search"));
            formik.setFieldValue("search_text", queryParams.get("search"))
        }
    }, [queryParams.get("search")])



    const handleLockOperation = async (job_order_id) => {
        if (!job_order_id) { toast.error("Could not get job order id."); return; };
        try {
            const result = await Swal.fire({
                title: 'Lock the Operation?',
                text: "By Locking, you won't be able to add more expenses.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!',
                cancelButtonText: 'No, cancel!',
            });


            if (result.isConfirmed) {
                axios.post(`${adminMainUrl}/api/jobOrder/operation/expense/lock-joborder`, { job_order_id: job_order_id }, { headers: { "auth-token": token, "user_id": user_id } })
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            dispatch(getOperationExpenseList(token, user_id, job_order_id, queryParams.get("page") ?? 1, queryParams.get('search')));
                        } else {
                            toast.success(response.data.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        let errmsg = "Internal server error."
                        if (error && error.response && error.response.data && error.response.data.msg) {
                            errmsg = error.response.data.msg;
                        }
                        toast.error(errmsg);
                    })
            }
        } catch (error) {
            console.error("Error changing status:", error);
            toast.error("An error occurred while locking job order.");
        }
    };



    function formatDate(dateString) {
        if (dateString) {
            const date = new Date(dateString);

            // Check if the date is valid
            if (isNaN(date.getTime())) {
                return ""; // Return an empty string if the date is invalid
            }

            const day = String(date.getDate()).padStart(2, "0");
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
        }
    }

    function formatTime(dateString) {
        if (!dateString) return 'Invalid date'; // handle cases where dateString is undefined or null

        const date = new Date(dateString);

        // Extract time components
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        // const seconds = String(date.getSeconds()).padStart(2, "0");

        // Return only the formatted time string
        return `${hours}:${minutes}`;
    }



    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Expense List<span className="count-title">{OperationExpenseListTotalData ?? "0"}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {b64id && <div className="card my-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="" className='form-label'>Job Order No.:</label>
                                    <input
                                        type="text"
                                        className='form-control form-control-sm'
                                        value={OperationExpenseListJobOrderNumber ?? ""}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="" className='form-label'>Quotation No.:</label>
                                    <input
                                        type="text"
                                        className='form-control form-control-sm'
                                        value={OperationExpenseListHasQuotationNumber ? OperationExpenseListQuotationNumber ?? "" : "This Job Order has no quotation."}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>}
                    <div className="card">
                        <div className="card-header">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    {/* <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search "
                                                name='search_text'
                                                value={formik.values.search_text}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">


                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>


                                            {
                                                // accessedPermission.includes("add_quote_request_form") &&  
                                                <div
                                                    className="btn btn-primary cursor-pointer"
                                                    onClick={handleOpenAdd}
                                                >
                                                    <i className="ti ti-square-rounded-plus me-2" />
                                                    Add Expense
                                                </div>}
                                        </div>
                                    </div> */}

                                    <div className="text-end">
                                        {OperationExpenseListJobOrderLocked ?
                                            <><b className="text-danger"><i className="fa-solid fa-lock mx-1"></i>LOCKED</b></>
                                            :
                                            <>
                                                <div
                                                    className="btn btn-primary cursor-pointer mx-1"
                                                    onClick={handleOpenAdd}
                                                >
                                                    <i className="ti ti-square-rounded-plus me-2" />
                                                    Add Expense
                                                </div>
                                                <div
                                                    className="btn btn-primary cursor-pointer mx-1"
                                                    onClick={() => handleLockOperation(OperationExpenseListJobOrderID)}
                                                >
                                                    <i className="fa-solid fa-lock me-2"></i> Lock Operation
                                                </div>
                                            </>


                                        }
                                    </div>
                                </div>
                            </form>
                        </div>


                        <div className="card-body">
                            {
                                showLoader ?
                                    <>
                                        <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <Beatloader />
                                        </div>
                                    </> :
                                    <>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>


            <AddOperationExpenseOffcanvas
                show={showAdd}
                handleClose={handleCloseAdd}
                b64id={b64id}
                loadingExpenseType={loadingExpenseType}
                expenseTypeOptions={expenseTypeOptions}
                currencyOptions={currencyOptions}
                loadingCurrency={loadingCurrency}
                refresh={refresh}
            />
            <EditOperationExpenseOffcanvas
                show={showEdit}
                handleClose={handleCloseEdit}
                b64id={b64id}
                loadingExpenseType={loadingExpenseType}
                expenseTypeOptions={expenseTypeOptions}
                currencyOptions={currencyOptions}
                loadingCurrency={loadingCurrency}
                refresh={refresh}
                expense_id={expense_id}
                loadingOperationExpenseDetail={loadingOperationExpenseDetail}
                OperationExpenseDetail={OperationExpenseDetail}
                OperationExpenseDetailError={OperationExpenseDetailError}
            />


            {/* Remark Offcanvas */}
            <Offcanvas show={showRemarks} onHide={handleCloseRemarks}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Remarks</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        loadingOperationExpenseRemarkList ?
                            <Beatloader /> :
                            OperationExpenseRemarkListError ?
                                <div className='text-center'>{OperationExpenseRemarkListError}</div>
                                :
                                <>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <form onSubmit={formikRemark.handleSubmit}>
                                                <div className="col-md-4 my-1">
                                                    <label className='form-label-cus' htmlFor="Expenseremark">Add Remark:</label>
                                                </div>
                                                <div className="col-md-12 my-1">
                                                    <textarea
                                                        className='form-control'
                                                        name="remark"
                                                        id="remark"
                                                        onChange={formikRemark.handleChange}
                                                        onBlur={formikRemark.handleBlur}
                                                        value={formikRemark.values.remark}
                                                    ></textarea>
                                                </div>
                                                <div className="text-end my-1">
                                                    <button className="btn btn-sm btn-primary" type="submit" disabled={disableRemarkSubmit}>{disableRemarkSubmit ? <> <i className="fas fa-spinner fa-spin mx-1"></i>Adding... </> : <>Add New Remark</>}</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    {
                                        remarkMessage.map((value, index) => {
                                            return <Accordion defaultActiveKey={`${index}`} key={index} className='mb-3'>
                                                <Accordion.Item eventKey={index.toString()} >
                                                    <Accordion.Header className='remark-accordion'>
                                                        {/* {new Date(value?.created_at).toISOString().split('T')[0]}{" "} */}
                                                        <div className="remark-header-content w-100 d-flex justify-content-between">
                                                            <span className="remark-user remark-font-14">
                                                                {value?.remark_sent_user_type == "ACCOUNT" ? <RoundedSmallButton alphabet={"A"} title={"Accounts"} /> : value.remark_sent_user_type == "OPERATION" ? <RoundedSmallButton alphabet={"O"} title={"Operation"} /> : null}
                                                                {value?.remark_user_info ? `${value?.remark_user_info?.name} (${value?.remark_user_info?.role})` : "-"}
                                                            </span>
                                                            <div className='d-flex justify-content-start align-items-center gap-3'>
                                                                <span className="remark-date remark-font-14">{formatDate(value?.createdAt)}</span>
                                                                <span className="remark-date remark-font-14">{formatTime(value?.createdAt)}</span>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body className="remark-accordion-body-show-query">
                                                        {value?.remark}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        })
                                    }
                                </>
                    }
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}


export default OperationExpense